/**
 * Shell for About and legal pages, readable by everyone: members get the
 * normal app shell (navigation stays), visitors a light public frame.
 */
import { Link, Outlet } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import MainLayout from '../layout/MainLayout';
import BrandMark from '../brand/BrandMark';
import SiteFooter from './SiteFooter';

function PublicInfoLayout() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <header className="sticky top-0 z-40 border-b border-[hsl(var(--mg-steel)/0.15)] bg-background/90 backdrop-blur-xl mg-safe-top">
        <div className="max-w-6xl mx-auto h-14 px-4 flex items-center justify-between gap-3">
          <Link to="/" className="flex items-center gap-2.5 min-w-0" aria-label="Midgard">
            <BrandMark size={30} />
            <span className="mg-wordmark text-base text-foreground hidden min-[360px]:inline" style={{ letterSpacing: '0.12em' }}>Midgard</span>
          </Link>
          <nav className="flex items-center gap-2">
            <Link to="/auth?mode=login" className="mg-btn mg-btn-ghost h-9 px-3 text-sm inline-flex items-center">Sign in</Link>
            <Link to="/auth" className="mg-btn mg-btn-primary h-9 px-4 text-sm inline-flex items-center">Join</Link>
          </nav>
        </div>
      </header>
      <main className="flex-1"><Outlet /></main>
      <SiteFooter />
    </div>
  );
}

export default function InfoShell() {
  const { user, loading } = useAuth();
  if (loading) return <div className="min-h-screen bg-background" />;
  return user ? <MainLayout /> : <PublicInfoLayout />;
}
